import DinInfoContent from './DinInfoContent';
export default DinInfoContent;
